module.exports = __webpack_public_path__ + "img/ikon_marla.939a17f3.svg";